<template>
  <div class='proCenter_box'>
    <div v-if='isFixed' class='icon_pc_search animated fadeIn' @click='antiSearchBox'>
      <div class='round'></div>
      <div class='stick'></div>
    </div>
    <div v-if='isShowSearch' class='fix_search_pc animated slideInDown faster'>
      <div class='w_1200'>
        <div class='fix_top'>
          <router-link to='/' class='logo img_box dis_ib ver_m nav-item'>
            <img src='../../assets/icons/logo_tab@2x.png' alt=''>
          </router-link>
          <div class='icon_close_btn iconic_close iconfont' @click='antiSearchBox'></div>
        </div>
        <div class='fz_0 text_center'>
          <input v-model='searhWord' class='search_input dis_ib' type='text' :placeholder='$t("goods.search.placeholder")' @focus='isSearch = false'>
          <div class='search_btn more' @click='searchGood(searhWord)'>{{ $t('goods.search.button') }}</div>
        </div>
      </div>
    </div>
    <div class='pub_bottom_block'>
      <div class='icon icon_goods_search hide' @click='showMenu("showGoodsSearchMenu")'></div>
      <div class='pub_tit'>{{ $t('goods.search.title') }}</div>
      <div class='fz_0 text_center'>
        <input v-model='searhWord' type='text' :placeholder='$t("goods.search.placeholder")' class='dis_ib'>
        <div class='more' @click='searchGood(searhWord)'>{{ $t('goods.search.button') }}</div>
      </div>
    </div>
    <div class='show_cate hide' :class='{active: isChoosen}' @click='showMenu("showGoodsCateMenu")'>
      {{ $t('goods.category.title') }}
      <div class='icon icon_goods_cate' :class='{active: isChoosen}'></div>
    </div>
    <div v-if='hotSearch && hotSearch.length' id='typeBox' class='type_box text_center fz_0'>
      <span class='dis_ib ver_m'>{{ $t('goods.category.hot') }}：</span>
      <a v-for='item in hotSearch' :key='item.id' href='javascript:void(0)' :class='{cur: currentTagId === item.id}' @click='clickHotSearch(item.id)'>{{ item.name }}</a>
    </div>
    <!-- 页面滑动给class加fixed -->
    <div id='menuBox' class='menu_box animated faster' :class='{extend: showAll, "slideInDown fixed": isFixed}'>
      <ul class='fz_0 w_1200'>
        <li class='all slide_li' :class='currentFirstCate === allText ? "cur" : "" ' @click='clickCate({name: allText, id: 0}, -1)'>
          <span>{{ allText }}</span><i></i>
        </li>
        <li v-for='(item,index) in cateList' :key='item.id'
            class='all slide_li' :class='{cur: isActiveParent[index], li_more: item.subs.length, none: !showAll && index > 7}' @click='clickCate(item, index)'
        >
          <span>{{ item.name }}</span>
          <i></i>
          <div class='slide_box'>
            <div v-for='(child, childIndex) in item.subs' :key='child.id'
                 class='child_item' :class='{cur: currentFirstCate === child.name}' @click.stop='clickCate(child, `${index}/${childIndex}`)'
            >
              {{ child.name }}
            </div>
          </div>
        </li>
        <li v-if='!showAll && cateList.length > 10' class='more_btn' @click='loadMoreCate'>
          <span>{{ $t('goods.category.more') }}</span>
        </li>
      </ul>
    </div>
    <div v-if='bookInfo && bookInfo.total_count' class='pro_item' :style='{paddingTop: isFixed && device !== "mobile" ? menuHeight : 0}'>
      <div v-if='goodsSearhWord' class='tit text_center'>{{ searchResultText }}</div>
      <div v-else class='tit text_center'>{{ totalText }}</div>
      <div class='w_1200'>
        <ul v-if='bookList.length' class='fz_0'>
          <li v-for='book in bookList' :key='book.id'>
            <div @click='toDetail(book)'>
              <div class='img_box'><img :src='book.image' alt='商品图'></div>
              <h3>{{ book.name }}</h3>
            </div>
          </li>
        </ul>
        <div v-if='bookInfo.total_count' class='tit text_center'>{{ checkedText }}</div>
        <a v-if='bookInfo.total_count !== bookInfo.view_number' href='javascript:void(0)' class='load_more' @click='loadMore'>{{ $t('goods.search.more') }}</a>
      </div>
    </div>
    <div v-else class='pro_item'>
      <div class='tit text_center no_data'>{{ $t('goods.search.result') }}</div>
    </div>
    <!-- 浏览搜索 -->
    <div class='dialog_box search_dialog hide'>
      <div class='dialog'>
        <div class='w_1200 pos_r'>
          <div class='logo_box'>
            <a href='#' class='logo img_box dis_ib ver_m'>
              <img :src='LogoTab' width='145' alt=''></a>
            <div class='fr icon_close_btn iconic_close iconfont'></div>
          </div>
          <div class='search_box text_center'>
            <input type='text' :placeholder='$t("goods.search.placeholder")' class='dis_ib ver_m'>
            <a href='#' class='more more2'>{{ $t('goods.search.button') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class='fix_right hide' :class='{gone: !isShowIconRight}'>
      <div class='fix_item fix_search' @click='showMenu("showGoodsSearchMenu")'>
        <div class='icon_goods_search'></div>
      </div>
      <div class='fix_item fix_cate' @click='showMenu("showGoodsCateMenu")'>{{ $t('goods.category.titleShort') }}</div>
    </div>
    <goods-search-menu
      :data='hotSearch' :show='showGoodsSearchMenu' :current-tag-id='currentTagId'
      @clickHotSearch='clickHotSearch'
      @searchGood='searchGood'
      @close='closeMenu("showGoodsSearchMenu")'
    ></goods-search-menu>
    <goods-cate-menu
      :data='cateList' :show='showGoodsCateMenu'
      :is-choosen='isChoosen'
      :choosen-index='choosenIndex'
      @clickCate='clickCate'
      @close='closeMenu("showGoodsCateMenu")'
    ></goods-cate-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { setTitle, mediaDevice } from 'utils'
import LogoTab from '@/assets/icons/logo_tab@2x.png'
import { getAllCateByTypeName, getBookByCategoryId, searchByWord, getAllTags, getTagBooks } from 'service/index'
import GoodsSearchMenu from '@/components/GoodsSearchMenu'
import GoodsCateMenu from '@/components/GoodsCateMenu'

export default {
  name: 'GoodsCenter',
  components: { GoodsSearchMenu, GoodsCateMenu },
  data () {
    return {
      LogoTab,
      isLoading: false,
      isFixed: false,
      isShowSearch: false,
      menuHeight: '0',
      device: '',
      searhWord: '',
    }
  },
  computed: {
    ...mapState([
      'hotSearch',
      'cateList',
      'showAll',
      'currentFirstCate',
      'currentCateId',
      'bookInfo',
      'bookList',
      'page',
      'total',
      'showGoodsSearchMenu',
      'showGoodsCateMenu',
      'isChoosen',
      'choosenIndex',
      'isShowIconRight',
      'currentTagId',
      'goodsSearhWord',
    ]),
    isActiveParent () {
      const list = []
      if (!this.cateList) return list
      for (let item of this.cateList) {
        if (this.currentFirstCate === item.name) {
          list.push(true)
        } else {
          const isChild = item.subs.some(child => child.name === this.currentFirstCate)
          if (isChild) {
            list.push(true)
          } else {
            list.push(false)
          }
        }
      }
      return list
    },
    allText () {
      // 根据语言版本更改当前选中值的文本
      if (this.currentFirstCate === '全部' || this.currentFirstCate === 'All') {
        this.setData({ currentFirstCate: this.$t('goods.category.all') })
      }
      // 根据语言版本获取“全部”文案
      return this.$t('goods.category.all')
    },
    searchResultText () {
      if (this.$i18n.locale === 'en') {
        return this.$t('goods.search.resultNumber').replace('n', `${this.bookInfo.total_count ? this.bookInfo.total_count : 0}`)
      }
      return `${this.bookInfo.total_count ? this.bookInfo.total_count : 0}个${this.goodsSearhWord}`
    },
    totalText () {
      if (this.$i18n.locale === 'en') {
        return this.$t('goods.search.resultNumber').replace('n', `${this.bookInfo.total_count ? this.bookInfo.total_count : 0}`)
      }
      return `找到${this.bookInfo.total_count ? this.bookInfo.total_count : 0}本书`
    },
    checkedText () {
      if (this.$i18n.locale === 'en') {
        return this.$t('goods.search.listNumber').replace('n', `${this.bookInfo.total_count}`).replace('m', `${this.bookInfo.view_number}`)
      }
      return `你已查看${this.bookInfo.total_count}本中的${this.bookInfo.view_number}本`
    },
  },
  methods: {
    ...mapActions(['setData']),
    antiSearchBox () {
      this.isShowSearch = !this.isShowSearch
    },
    showMenu (name) {
      document.body.className = 'fixed'
      this.setData({
        [name]: true,
      })
    },
    closeMenu (name) {
      document.body.className = ''
      this.setData({
        [name]: false,
      })
    },
    showIconRight () {
      if (mediaDevice() != 'mobile') {
        this.setData({
          isShowIconRight: false,
        })
      }
      window.onscroll = () => {
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop
        if (scrolltop > 300) {
          this.setData({
            isShowIconRight: true,
          })
        } else {
          this.setData({
            isShowIconRight: false,
          })
        }
      }
    },
    loadMoreCate () {
      this.setData({
        showAll: true,
      })
      const menuClientHeight = document.getElementById('menuBox').clientHeight
      this.menuHeight = menuClientHeight + 70 + 'px'
    },
    loadMore () {
      let page = this.page + 1
      this.setData({
        page,
      })
      if (this.isLoading || this.bookInfo.total_count === this.bookInfo.view_number) return
      if (this.currentFirstCate) {
        this.getBookByCid()
      } else {
        this.searchGood(this.searhWord)
      }
    },
    toDetail (book) {
      this.$router.push({ path: '/goods-detail?id=' + book.id })
    },
    clickHotSearch (id) {
      document.body.className = ''
      this.reset()
      this.setData({
        currentTagId: id,
        currentFirstCate: '',
        page: 1,
      })
      getTagBooks(id).then(res => {
        const bookList = res.data.items ? this.bookList.concat(res.data.items) : this.bookList.concat([])
        this.setData({
          bookInfo: res.data,
          bookList,
        })
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    searchGood (searhWord) { // mobile组件需要传值过来
      document.body.className = ''
      this.reset()
      this.isShowSearch = false
      this.isLoading = true
      const q = encodeURIComponent(searhWord)
      searchByWord({
        q,
        page: this.page,
        per_page: 48,
      }).then(res => {
        const bookList = res.data.items ? this.bookList.concat(res.data.items) : this.bookList.concat([])
        this.setData({
          bookInfo: res.data,
          bookList,
          goodsSearhWord: this.searhWord,
        })
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    // 分类类型名称
    mouseCate () {
      getAllCateByTypeName().then(res => {
        this.setData({
          cateList: res.data,
        })
      })
    },
    clickCate (item, index) {
      document.body.className = ''
      this.reset()
      this.searhWord = ''
      this.setData({
        currentFirstCate: item.name,
        currentCateId: item.id,
        page: 1,
        choosenIndex: index.toString(),
        isChoosen: true,
      })
      this.getBookByCid()
    },
    getBookByCid () {
      this.isLoading = true
      getBookByCategoryId({
        categoryId: this.currentCateId,
        page: this.page,
        per_page: 48,
      }).then(res => {
        const bookList = res.data.items ? this.bookList.concat(res.data.items) : this.bookList.concat([])
        this.setData({
          bookInfo: res.data,
          bookList,
        })
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    onScroll () {
      const target = document.getElementById('typeBox')
      if (target) {
        const targetTop = target.offsetTop
        const bodyScrollTop = Number(document.body.scrollTop || document.documentElement.scrollTop)
        setTimeout(() => {
          if (bodyScrollTop > targetTop) {
            this.isFixed = true
            this.setData({
              isFixedNavBar: true,
            })
          } else {
            this.isFixed = false
            this.setData({
              isFixedNavBar: false,
            })
          }
        }, 100)
      }
    },
    reset () {
      this.setData({
        bookInfo: null,
        bookList: [],
        currentTagId: '',
        currentFirstCate: this.allText,
        isChoosen: false,
        choosenIndex: '-1',
        goodsSearhWord: '',
      })
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.navigation.goods')}`)
    this.showIconRight()
  },
  mounted () {
    // 获取数据
    const target = document.getElementById('menuBox')
    const menuClientHeight = target.clientHeight
    window.addEventListener('scroll', this.onScroll)
    this.menuHeight = menuClientHeight + 70 + 'px'
    if (this.goodsSearhWord) {
      this.searhWord = this.goodsSearhWord
    }
    if (this.bookInfo) return
    // 获取所有类目
    this.mouseCate()
    getAllTags().then(res => {
      this.setData({
        hotSearch: res.data,
      })
    })
    this.getBookByCid()
    this.device = mediaDevice()
  },
  beforeDestroy () {
    if (this.searhWord) {
      this.setData({
        goodsSearhWord: this.searhWord,
      })
    }
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>
<style lang='less' scoped>
.icon_pc_search {
  position: fixed;
  top: 10px;
  left: 50%;
  margin-left: 355px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 3;
  cursor: pointer;
  &:hover,
  &:active,
  &.active {
    background: rgba(245, 245, 245, 1);
    .round {
      border: 2px solid rgba(63, 70, 173, 1);
      background: rgba(245, 245, 245, 1);
    }
    .stick {
      background: rgba(63, 70, 173, 1);
    }
  }
}
.round {
  position: absolute;
  top: 13px;
  left: 12px;
  z-index: 2;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(29, 29, 29, 1);
  background: rgba(255, 255, 255, 1);
  border-radius: 50%;
}
.stick {
  position: absolute;
  top: 26px;
  right: 17px;
  z-index: 1;
  width: 2px;
  height: 12px;
  background: rgba(29, 29, 29, 1);
  transform: rotate(133deg);
}
.fix_search_pc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  padding-top: 18px;
  padding-bottom: 100px;
  background: rgba(255, 255, 255, 1);
}
.fix_top {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    display: block;
    width: 145px;
    height: auto;
  }
  .icon_close_btn {
    right: -20px;
    top: -15px;
    padding: 20px;
  }
}
.search_input {
  border-color: rgba(105, 105, 105, 1);
  color: rgba(51, 51, 51, 1);
  &::placeholder {
    color: rgba(117, 117, 117, 1) !important;
  }
}
.search_btn {
  background: rgba(63, 70, 173, 1);
  color: rgba(255, 255, 255, 1);
  border: none;
  &:hover {
    border: none;
    background: rgba(56, 62, 155, 1);
  }
}
.proCenter_box {
  .no_data {
    display: block;
    margin: 180px 0;
    color: #999;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .icon_pc_search {
    margin-left: 265px;
  }
}
</style>
